import { IGif } from '@giphy/js-types'
import { shuffle } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useChannelGifPaginator } from 'shared/api/channels'
import Loader from 'shared/components/loaders/dots'
import { grid12 } from 'shared/util/grid'
import styled from 'styled-components'
import { PurpleButton } from '../../buttons'
import Starter from './starter-item'

const CHANNEL_ID = 26187069
const NUM_ITEMS = 9

const Container = styled.div`
    margin: 0 auto;
    min-height: 190px;
    position: relative;
    width: ${grid12}px;
`

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
`

const Footer = styled.div`
    bottom: 0;
    left: 0;
    padding: 30px 0;
    position: absolute;
    text-align: center;
    width: 100%;

    &:before {
        background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
        bottom: 0;
        content: '';
        height: 190px;
        left: 0;
        pointer-events: none;
        position: absolute;
        width: 100%;
    }
`

const FooterInner = styled.div`
    position: relative;

    button {
        min-width: 260px;
    }
`

const Gif = styled(Starter)`
    margin-bottom: 10px;
    margin-right: 10px;

    &:nth-child(3n) {
        margin-right: 0;
    }
`

const ZoomMakerStarterGrid = () => {
    const [gifs = [], fetchChannelGifs, isFinished] = useChannelGifPaginator(CHANNEL_ID)
    const [shuffledGifs, setShuffledGifs] = useState<IGif[]>([])
    const [showCount, setShowCount] = useState<number>(NUM_ITEMS)
    const [isFetching, setIsFetching] = useState<boolean>(false)

    useEffect(() => {
        if (!gifs.length) {
            fetchGifs()
        } else {
            const newGifs = shuffle(gifs.slice(shuffledGifs.length))
            setShuffledGifs([...shuffledGifs, ...newGifs])
        }
    }, [gifs])

    const fetchGifs = async () => {
        setIsFetching(true)
        await fetchChannelGifs()
        setIsFetching(false)
    }

    const showMore = () => {
        const newShowCount = showCount + NUM_ITEMS
        setShowCount(newShowCount)
        if (!isFinished && newShowCount >= gifs.length) {
            fetchGifs()
        }
    }

    return (
        <Container>
            <Grid>{shuffledGifs.map((gif, i) => (i < showCount ? <Gif key={gif.id} gif={gif} /> : null))}</Grid>
            {(showCount < gifs.length || isFetching) && (
                <Footer>
                    <FooterInner>
                        {isFetching ? <Loader /> : <PurpleButton onClick={showMore}>Load More</PurpleButton>}
                    </FooterInner>
                </Footer>
            )}
        </Container>
    )
}

export default ZoomMakerStarterGrid
